<template>
<div>
    <v-card max-width="700" style="" class="mx-auto text-center my-4 pa-4">
        <v-btn :disabled="loadBtn" v-if="cali" @click="cali = false">edit my dates</v-btn>
       <div v-else>

   <h2  v-if="clicked_date" class="py-4 px-4 grey--text">{{focus | myDate}}</h2>
        <v-sheet dark style="" class=" my-4 mx-auto" max-width="500" height="450">
      <v-calendar dark
        ref="calendar" 
        v-model="focus"  @click:date="clicker"
         :event-overlap-threshold="30"
        :events="events"
      ></v-calendar>
    </v-sheet>      
    <div class="py-1" style="height:60px;position:relative" >
          <v-btn
            fab
            left
            absolute 
            
            color="#f5f0c9"
            @click="prev"
          >
            <v-icon color="black"  >
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            
            smll absolute    right
            color="#f5f0c9"
            @click="next"
          >
            <v-icon color="black" >
              mdi-chevron-right
            </v-icon>
          </v-btn>
      </div>
</div>

<v-btn v-if="clicked_date" :loading="loadBtn" class="my-12" x-large @click="updateDates()"> submit</v-btn>
    </v-card>
    <v-dialog max-width="400" v-model="clicked_dialog">
        <keep-alive>
        <v-card max-width="400" class="text-center pa-5">
            {{!remove? 'Add': 'Remove'}} {{clicked_date | myDate}}
            <div class="pt-5">
                <v-btn @click="actonDate()">sure</v-btn>
                <v-btn class="mx-4" @click="clicked_dialog = false">cancel</v-btn>
            </div>
            
        </v-card>
        </keep-alive>
    </v-dialog>
</div>
</template>
  <script>
import axios from "axios";
// MukIJrmHC}da
export default {
mounted(){
   
        axios.get('https://djslimv.com/backend/api/jobs/get_events').then((res)=>{
// this.events = res.data.events;
this.loadBtn = false
        })
},
          data(){
return {
    cali: true,
    clicked_dialog: false,
    loadBtn: true,
   focus: '',
    events: [
        {
            name: 'Taken',
               start: '2021-07-16',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-07-17',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-07-24',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-07-31',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-08-07',
            timed: false,
          },
          {
              name: 'Taken',
                  start: '2021-08-13',
              timed: false,
            },
        {
            name: 'Taken',
               start: '2021-08-14',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-08-19',
            timed: false,
          },
        {
            name: 'Taken',
                start: '2021-08-20',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-08-21',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-08-27',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-08-28',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-09-09',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-09-11',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-09-25',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-01',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-02',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-03',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-08',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-09',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-10',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-15',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-16',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-23',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-27',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-28',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-10-29',
            timed: false,
          },
          {
              name: 'Taken',
                 start: '2021-11-03',
              timed: false,
            },
        {
            name: 'Taken',
               start: '2021-11-13',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-14',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-19',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-20',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-21',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-27',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-11-28',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-18',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-22',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-23',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-26',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-27',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-28',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-29',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-30',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2021-12-31',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-01',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-02',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-03',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-04',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-05',
            timed: false,
          },
        {
            name: 'Taken',
               start: '2022-01-06',
            timed: false,
          },
        {
            name: 'Taken',
            start: '2022-01-08',
               timed: false,
          },
      
        {
            name: 'Taken',
            start: '2022-01-15',
               timed: false,
          },
        {
            name: 'Taken',
            start: '2022-01-16',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-03',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-05',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-10',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-12',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-14',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-02-26',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-03-05',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-03-24',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-03-25',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-03-26',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-03-31',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-02',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-09',
               timed: false,
          },
  
            {
            name: 'Taken',
            start: '2022-04-16',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-19',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-20',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-22',
            timed: false,
          },
            {
            name: 'Taken',
            start: '2022-04-23',
               timed: false,
          },
                    {
            name: 'Taken',
            start: '2022-04-30',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-05-08',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-05-14',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-05-28',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-06-09',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-06-11',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-06-20',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-06-25',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-06-30',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-07-08',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-07-09',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-07-23',
               timed: false,
          },
          {
            name: 'Taken',
            start: '2022-07-30',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-08-20',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-08-27',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-09-03',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-09-10',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-11-26',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-3',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-10',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-16',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-22',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-23',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-24',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-27',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-28',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-29',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-30',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2022-12-30',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2023-01-04',
               timed: false,
          },
            {
            name: 'Taken',
            start: '2023-01-07',
               timed: false,
          },
    ],
    dialogCalender: false,
    dialogEnquiry: false,
    clicked_date: '',
    remove: false,
}
},
complete: {
      tod(){
       return  moment().tz('Africa/Lagos').format("ddd MMM DD YYYY kk:mm:ss ZZ").replace("+0100", "GMT+0100")
    } ,
},
methods: {
    updateDates(){
        this.loadBtn = true
        axios.post('https://djslimv.com/backend/api/jobs/events',{
            events: this.events
        }).then((res)=>{
            this.loadBtn = false
            alert('Your dates has been updated.')
        }).catch((err)=>{
            this.loadBtn = false
            alert('An error occured.')
        })

    },
    actonDate(){

   
        this.clicked_dialog = false
    },
    clicker(e){
        console.log(e)
        var events = this.events
        this.remove = events.some((el)=>{
            return el.start == e.date
        })

        this.clicked_date = e.date
           if (this.remove) {
            this.events = this.events.filter((el)=>{
                return el.start != this.clicked_date
            })
        }else{
            this.events.push({start: this.clicked_date,
            name: "Taken",
            timed: false})
        }
    },
  openCalender(){
this.dialogCalender = true
        console.log(this.$refs.calendar.$options)

  },
      prev () {
        console.log(this.$refs.calendar.$options)
        this.$refs.calendar.prev()
      },
      next () {
        console.log(this.$refs.calendar.$options)
        this.$refs.calendar.next()
      },
}
}
</script>